import axios, { AxiosResponse } from "axios";
import React, { FC, useContext, useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { Checkbox, Icon, Popup, Table, Loader } from "semantic-ui-react";
import { config } from "../../contexts/UrlContext";
import history from "../../History";
import { getIcon } from "../Shared/Util";
import ExpandIcon from "./ExpandIcon";
import FileIcon from "./FileIcon";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";
import { IRecord, ITableActions, ITableField } from "../Interfaces/TableInterface";
import { getSubStringValue, stringIsEmpty } from "../../utils/stringUtils";

interface IProps {
    record: IRecord,
    viewDisplay: boolean,
    editDisplay: boolean,
    renditionDisplay: boolean,
    viewRenditionDisplay: boolean,
    downloadDisplay: boolean,
    displayFileIcon: boolean,
    displayRecIcon: boolean,
    wordWrap:boolean,
    gridId: string,
    addPadding: string,
    onChildChange: any
}


const ResultItem: FC<IProps> = ({ record, viewDisplay, editDisplay, renditionDisplay, viewRenditionDisplay, downloadDisplay, displayFileIcon, displayRecIcon, gridId, addPadding, onChildChange, wordWrap }) => {
    const [displayRelatedRec, setDisplayRelatedRec] = useState<boolean>(false);
    const [childRecords, setChildRecords] = useState<IRecord[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const { auth } = useContext(AuthContext);


    useEffect(() => {
    }, [displayRelatedRec]);

    const underlineStyle = {
        textDecoration: 'underline',
        cursor: 'pointer',
        color: 'blue',
        paddingLeft: addPadding !== "" ? addPadding : "none",
        wordWrap: "break-word !important"
    }

    const toggleDisplay = async (displayValue :boolean) => {
       
        //fetch child records if not already fetched
        if (displayValue === true && childRecords.length === 0) {
            setLoading(true);

            try {
                let response: AxiosResponse = await getRequest(auth, `/Grid/GetChildRecords?uri=${record.uri}&gridId=${gridId}`);
                if (response.data != null)
                {
                    setChildRecords(response.data);
                    setDisplayRelatedRec(displayValue);
                    onChildChange(response.data.length, true);
                }
                setLoading(false);
            } catch (error) {
                toast.error(error);
                setLoading(false);
            }
        }
        else {
            setDisplayRelatedRec(displayValue);
            onChildChange(childRecords.length, false);
        }
    }

    const editRecord = async () => {

        try {
            let response: AxiosResponse = await getRequest(auth, `/ContentManager/EditRecord?uri=${record.uri}&id=${gridId}`);

            let data = response.data;
            window.location.replace(data);
        } catch (error) {
            console.log(error);
            setLoading(false);
            toast.error(`Unable to edit Record. Please see logs for more info`);
        }
    }

    const viewRecord = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/ContentManager/ViewRecord?uri=${record.uri}&id=${gridId}`);

            let data = response.data;
            window.location.replace(data);
        } catch (error) {
            console.log(error);
            setLoading(false);
            toast.error(`Unable to edit Record. Please see logs for more info`);        
        }
    }

    const displayPDFRendition = async () => {
        setLoading(true);

        try {
            window.open(`${config.baseUrl}/api/Display/DisplayPDFRendition?uri=${record.uri}&tableId=${gridId}`, "_blank");
        } catch (error) {
            console.log(error);
            toast.error(`Unable to download Record. Please see logs for more info`);
        }
        setLoading(false);
    }

    const isRecordActionable = () => {
        let defaultAction = record.defaultAction;

        if (defaultAction === ITableActions.View && record.isDownloadable)
            return true;

        if (defaultAction === ITableActions.Edit && record.isEditable)
            return true;

        if (defaultAction === ITableActions.Download &&  record.isDownloadable)
            return true;

        if ((defaultAction === ITableActions.DownloadPDF || defaultAction === ITableActions.DisplayPDF) &&  record.isDownloadable)
            return true;

        return false;
    }

    const triggerAction = () => {
        let defaultAction = record.defaultAction;

        if (defaultAction === ITableActions.View)
            return viewRecord();

        if (defaultAction === ITableActions.Edit)
            return editRecord();

        if (defaultAction === ITableActions.Download)
            return downloadRecord("DownloadRecord");

        if (defaultAction === ITableActions.DownloadPDF)
            return downloadRecord("DownloadPDFRendition");

        if (defaultAction === ITableActions.DisplayPDF)
            return displayPDFRendition();

    }

    const downloadRecord = async (endpoint: string) => {
        setLoading(true);

        try {
            let response: AxiosResponse = await getRequest(auth, `/ContentManager/${endpoint}?uri=${record.uri}&id=${gridId}`);

            let files = response.data;

            let linkSource = `data:${files.mimeType};base64,${files.contents}`;
            let downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink);

            downloadLink.href = linkSource;
            downloadLink.target = '_blank';
            downloadLink.download = files.recordSuggestedFileName;
            downloadLink.click();
            

        } catch (error) {
            console.log(error);
            toast.error(error.response.data);
        }

        setLoading(false);
    }

    return (
        <>
            <Table.Row className="result-row" key={`${record?.uri}-result`} id={`${record?.uri}-result`} style={{ wordWrap: "break-word !important"}}>

                <Table.Cell style={{ width: "65px", cursor: 'pointer', paddingLeft: addPadding !== "" ? addPadding : "none" }}>
                    <div style={{ width: "100%", overflow: "hidden" }}>
                        <div style={{ display: "inline-flex" }}>
             
                            {record.childCount > 0 && (
                                
                                <ExpandIcon childRecords={record.childCount} displayChildRecords={displayRelatedRec} onClickCallback={toggleDisplay} key={`${record.uri}-expand`} />
                            )}

                            
                            {(displayFileIcon || displayRecIcon ) && (
                                <FileIcon record={record}
                                    key={`${record.uri}-fileIcon`}
                                    viewDisplay={viewDisplay}
                                    editDisplay={editDisplay}
                                    downloadDisplay={downloadDisplay}
                                    defaultAction={record.defaultAction}
                                />
                            )}

                            {loading && (
                                <Loader inline active size='mini'>Loading...</Loader>
                            )}
                        </div>
                    </div>
                </Table.Cell>
           
            
                {record.tableFields &&
                    record.tableFields.map((x: ITableField) => {
                        let isUrl = x.recordValue.includes("http") || x.recordValue.includes("https");
                        let recValue = stringIsEmpty(x.recordValue) ? "" : getSubStringValue(x.recordValue);

                        if (isUrl) {

                            return (
                                <Table.Cell key={`${x.fieldName.replace(" ", "")}-${record.uri}`} style={underlineStyle} onClick={() => window.open(x.recordValue, "_blank")}>
                                    {wordWrap === true ? x.recordValue : (recValue.includes("...") ? <Popup content={x.recordValue} trigger={<span>{recValue}</span>} /> : recValue)}
                                </Table.Cell>
                            )
                        }
                        else {

                            //identify if the action can be executed, if not it should not be underlined
                            let isActionable = isRecordActionable();

                            if (isActionable) {

                                return (
                                    <Table.Cell key={`${x.fieldName.replace(" ", "")}-${record.uri}`} style={underlineStyle} onClick={triggerAction}>
                                        {wordWrap === true ? x.recordValue : (recValue.includes("...") ? <Popup content={x.recordValue} trigger={<span>{recValue}</span>} /> : recValue)}
                                    </Table.Cell>
                                )
                            }

                            return (
                                <Table.Cell key={`${x.fieldName.replace(" ", "")}-${record.uri}`} style={{ cursor:"default", paddingLeft: addPadding !== "" ? addPadding : "none", wordWrap: "break-word !important" }}>
                                    {wordWrap === true ? x.recordValue : (recValue.includes("...") ? <Popup content={x.recordValue} trigger={<span>{recValue}</span>} /> : recValue)}
                                </Table.Cell>
                            )
                        }
                        

                       
                    
                    })
                }
                <Table.Cell textAlign={"right"}>
                    {(viewDisplay && record.isDownloadable) && (
                        <a><Popup content="View Record" trigger={<Icon name="eye" alt='View Record' id='view' style={{ cursor: 'pointer' }} onClick={() => viewRecord() } />} /></a>
                    )}
                    {(viewDisplay && !record.isDownloadable) && (
                        <Icon name="eye" alt='View Record' id='view-disabled' color='grey' />
                    )}


                    {(editDisplay && record.isEditable) && (
                        <a><Popup content="Edit Record" trigger={<Icon name="pencil alternate" alt='Edit Record' id='edit' style={{ cursor: 'pointer' }} onClick={() =>  editRecord()} />} /></a>
                    )}

                    {(editDisplay && !record.isEditable) && (
                        <Icon name="pencil alternate" alt='Edit Record' id='edit-disabled'  color='grey'/>
                    )}

                    {(downloadDisplay && record.isDownloadable) && (
                        <a><Popup content="Download Record" trigger={<Icon name="download" alt='Download Record' id='view' style={{ cursor: 'pointer' }} onClick={() => downloadRecord("DownloadRecord")} />} /></a>
                    )}
                    {(downloadDisplay && !record.isDownloadable) && (
                        <Icon name="download" alt='Download Record' id='download-disabled' color='grey' />
                    )}

                    {renditionDisplay && record.isDownloadable && (
                        <a><Popup content="Download PDF Rendition" trigger={<Icon name="file text" alt='Download PDF Rendition' id='download-pdfren' style={{ cursor: 'pointer' }}
                            onClick={() => downloadRecord("DownloadPDFRendition")} />} /></a>
                    )}

                    {renditionDisplay && !record.isDownloadable && (
                        <Icon name="file text" alt='Download PDF Rendition' id='pdfren-disabled' color='grey' />
                    )}

                    {viewRenditionDisplay && record.isDownloadable && (
                            <a><Popup content="View PDF Rendition" trigger={<Icon name="file pdf outline" color='black' alt='View PDF Rendition' id='view-pdfren' style={{ cursor: 'pointer' }}
                               onClick={displayPDFRendition} />} /></a>
                    )}

                    {viewRenditionDisplay && !record.isDownloadable && (
                        <Icon name="file pdf outline" alt='View PDF Rendition' id='view-pdfren-disabled' color='grey' />
                    )}

                </Table.Cell>
            </Table.Row>
            {childRecords.length > 0 && displayRelatedRec === true && (
                childRecords.map(function (child: IRecord) {
                    return (
                        <ResultItem record={child} viewDisplay={viewDisplay} editDisplay={editDisplay}
                            renditionDisplay={renditionDisplay} downloadDisplay={downloadDisplay}
                            displayFileIcon={displayFileIcon} displayRecIcon={displayRecIcon} viewRenditionDisplay={viewRenditionDisplay}
                            key={`${child.uri}-child`} gridId={gridId} addPadding="35px" onChildChange={onChildChange} wordWrap={ wordWrap} />
                    )
                })
            )}
        </>
    );
}

export default ResultItem;